/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import { ResponseType } from '../constants/enums';
import {
	ICreateQuestion,
	ICreateQuestionResponse,
	IQuestionDetails,
	IQuestionResponse,
} from '../interfaces/question';

export class OnboardingQuestionsService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getQuestionById(questionId: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().ONBOARDING_QUESTION
						.GET_QUESTION,
					null,
					{ reqPathParam: questionId },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addQuestion(newQuestionData: IQuestionDetails) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().ONBOARDING_QUESTION
						.ADD_QUESTION,
					this.formatQuestionReqData(newQuestionData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateQuestion(questionToUpdateData: IQuestionDetails) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().ONBOARDING_QUESTION
						.UPDATE_QUESTION,
					this.formatQuestionReqData(questionToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getAllQuestions(page?: number) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().ONBOARDING_QUESTION
						.GET_QUESTIONS,
					{},
					{
						pathParams: { page: page || 1 },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}

	deleteQuestion(questionId: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().ONBOARDING_QUESTION
				.DELETE_QUESTION,
			null,
			{ reqPathParam: questionId },
		);
	}
	private formatQuestionReqData(
		questionData: IQuestionDetails,
	): ICreateQuestion {
		return {
			...(questionData.id ? { id: questionData.id } : {}),
			title: questionData.title,
			imageId: questionData.image?.id,
			order: questionData.order,
			responseType: questionData.responseType,
			responses: questionData.responses.map(response =>
				this.formatQuestionResponseData(response, questionData.responseType),
			),
		};
	}

	private formatQuestionResponseData(
		{ id, title, description, icon, subTitle }: IQuestionResponse,
		responseType: ResponseType,
	): ICreateQuestionResponse {
		const formattedResponse: ICreateQuestionResponse = {
			...(id ? { id } : {}),
			title,
		};

		if (responseType === ResponseType.ONE_SELECTION_WITH_DESC) {
			formattedResponse.description = description;
			if (subTitle) formattedResponse.subTitle = subTitle;
		} else if (responseType === ResponseType.MULTIPLE_SELECTION) {
			formattedResponse.iconId = icon?.id;
		}

		return formattedResponse;
	}
}
